<template>
    <div>
        <b-modal
            v-model="mostrarModal"
            @show="obterTiposItens()"
            no-close-on-backdrop
        >
            <div slot="modal-title">{{ operacaoDescr }} Item</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Item</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposItensSelect"
                            v-model="tipoItemId"
                            text-field="descricao"
                            value-field="tipoItemId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- {{ tipoItem }} -->
            <b-row v-if="tipoItem && tipoItem.tipo == 2">
                <b-col sm="12">
                    <b-form-group>
                        <label>Armazenamento</label>
                        <b-form-select
                            :plain="true"
                            :options="armazenamentosSelect"
                            v-model="armazenamento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Nível de Acesso</label>
                        <b-form-select
                            :plain="true"
                            :options="niveisAcessoSelect"
                            v-model="nivelAcesso"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Nome</label>
                        <b-form-input
                            type="text"
                            v-model="nome"
                            @input="$v.nome.$touch()"
                            :state="$v.nome.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O nome é obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatóri</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="tipoItem && armazenamento == 0">
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Endereço (URL)</label>
                        <b-form-textarea
                            v-model="url"
                            :rows="4"
                            @input="$v.conteudo.$touch()"
                            :state="$v.conteudo.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O endereço do item é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="tipoItem && armazenamento == 1">
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="cancelar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvar()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BaseConhecimentoServicos from './BaseConhecimentoServicos'

export default {
    props: {
        mostrarModal: {
            type: Boolean
        },

        operacao: {
            type: String
        },

        item: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            tiposItensSelect: [],
            tipoItemId: '',
            armazenamentosSelect: [
                { text: 'REMOTO', value: 0 },
                { text: 'LOCAL', value: 1 }
            ],
            armazenamento: 0,
            nome: '',
            descricao: '',
            url: '',
            arquivo: null,
            niveisAcessoSelect: [
                { text: 'TODOS', value: 0 },
                { text: 'FORNECEDORES', value: 1 },
                { text: 'GESTORES', value: 2 },
                { text: 'GERENTES', value: 3 }
            ],
            nivelAcesso: 0
        }
    },

    methods: {
        cancelar() {
            this.$emit('fecharModal')
        },

        reiniciarForm() {
            this.tipoItemId = ''
            this.nome = ''
            this.descricao = ''
            this.url = ''
            this.armazenamento = 0
            this.nivelAcesso = 0
            this.arquivo = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.tipoItemId = this.item.tipoItemId
            this.nome = this.item.nome
            this.descricao = this.item.descricao
            this.url = this.item.url
            this.nivelAcesso = this.item.nivelAcesso
        },

        salvar() {
            this.$store.dispatch('addRequest')
            if (this.operacao === 'I') {
                let promisse
                if (this.armazenamento == 0) {
                    let itemDto = {
                        tipoItemId: this.tipoItemId,
                        nome: this.nome,
                        descricao: this.descricao,
                        url: this.url,
                        nivelAcesso: this.nivelAcesso
                    }
                    promisse = BaseConhecimentoServicos.inserirItemRemoto(
                        itemDto
                    )
                } else {
                    let itemDto = {
                        tipoItemId: this.tipoItemId,
                        nome: this.nome,
                        descricao: this.descricao,
                        arquivo: this.arquivo,
                        nivelAcesso: this.nivelAcesso
                    }
                    promisse = BaseConhecimentoServicos.inserirItemLocal(
                        itemDto
                    )
                }

                promisse.then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Item inserido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.reiniciarForm()
                            this.$emit('atualizarListaItens', response.data)
                            this.$emit('fecharModal')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                let promisse
                if (this.armazenamento == 0) {
                    let itemDto = {
                        itemId: this.item.itemId,
                        tipoItemId: this.tipoItemId,
                        nome: this.nome,
                        descricao: this.descricao,
                        url: this.url,
                        nivelAcesso: this.nivelAcesso
                    }
                    promisse = BaseConhecimentoServicos.atualizarItemRemoto(
                        itemDto
                    )
                } else {
                    let itemDto = {
                        itemId: this.item.itemId,
                        tipoItemId: this.tipoItemId,
                        nome: this.nome,
                        descricao: this.descricao,
                        arquivo: this.arquivo,
                        nivelAcesso: this.nivelAcesso
                    }
                    promisse = BaseConhecimentoServicos.atualizarItemLocal(
                        itemDto
                    )
                }

                promisse.then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Item atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.reiniciarForm()
                            this.$emit('atualizarListaItens', response.data)
                            this.$emit('fecharModal')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterTiposItens() {
            this.$store.dispatch('addRequest')
            BaseConhecimentoServicos.obterTiposItens().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposItensSelect = response.data
                        if (this.operacao == 'A') {
                            this.preencherForm()
                        }
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos dos itens!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {
        tipoItem() {
            return this.tiposItensSelect.find(
                p => p.tipoItemId == this.tipoItemId
            )
        },

        operacaoDescr() {
            return this.operacao == 'I' ? 'Inserir' : 'Atualizar'
        }
    },

    watch: {
        tipoItem() {
            this.armazenamento =
                this.tipoItem.tipo == 2 ? 0 : this.tipoItem.tipo
        },

        armazenamento() {
            this.url = ''
            this.arquivo = null
        }
    },

    validations: {
        tipoItemId: {
            required
        },
        nome: {
            required
        },
        descricao: {
            required
        },
        conteudo: {
            valido() {
                if (this.armazenamento == 0) {
                    return this.url != null && this.url != ''
                } else {
                    return this.arquivo != null
                }
            }
        }
    }
}
</script>
